import ContentTypeNumber from './content-type-number';
import './content-type-number.scss';

export default ContentTypeNumber;
